import {Component, HostBinding} from '@angular/core';

const componentBaseName = 'content-container';
const selectorName = `cat-${componentBaseName}`;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.scss'],
})
export class ContentContainerComponent {
  @HostBinding('class') classNames = defaultClassNames;

  constructor() {
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/components/content-container/content-container.component.ts